import { useTranslation } from 'react-i18next';

import { Text } from '@elements/text';
import { TextWithMd } from '@elements/text/textWithMd';
import { i18n } from '@i18n';
import { sluggify, testProps } from '@utils';

import { Item, iconMap } from './whatsNext.types';

export const WhatsNext = () => {
  const { t } = useTranslation();
  const listItems = t('confirmation.whatsNext.items', {
    returnObjects: true,
  }) as unknown as Item[];

  return (
    <div className="flex flex-col gap-s24">
      <div className="flex flex-col gap-s16">
        <Text {...testProps('confirmation-whatsNext-title')} variant="subTitle-20/sb">
          {i18n.t('confirmation.whatsNext.title')}
        </Text>
        <TextWithMd {...testProps('confirmation-whatsNext-description')}>
          {i18n.t('confirmation.whatsNext.description')}
        </TextWithMd>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-s20">
        {listItems.map(it => (
          <ListItem icon={it.icon} title={it.title} key={it.icon} />
        ))}
      </div>
    </div>
  );
};

const ListItem = ({ icon, title }: Item) => {
  const Icon = iconMap[icon];
  return (
    <div className="flex flex-col flex-1 gap-s16 ">
      <div className="flex rounded-[32px] p-s8 bg-cabo-50 w-16 h-16 justify-center items-center">
        <Icon height={48} width={48} />
      </div>
      <Text {...testProps(`confirmation-whatsNext-item-${sluggify(icon)}`)} variant="body-16/sb">
        {title}
      </Text>
    </div>
  );
};
